import { useQuery } from '@tanstack/react-query';
import { listQueryDefaults } from '../../../lib/query/listQuery';
import { getLeadsKanban } from '../api/leads';

export interface UseLeadsKanbanParams {
  sourceId?: number;
  campaignId?: string;
  contactCategoryId?: number;
  segmentIds?: string[];
}

export function useLeadsKanban(params: UseLeadsKanbanParams = {}) {
  return useQuery({
    queryKey: ['leads-kanban', params],
    queryFn: () => getLeadsKanban(params),
    ...listQueryDefaults,
  });
}
